import { createContext } from 'react'
import type { Notification } from '../types'

/**
 * Тип контекста уведомлений
 */
export type NotificationContextType = {
  // Данные уведомлений
  notifications: Notification[]
  
  // Состояние загрузки
  isLoading: boolean
  hasMore: boolean
  /** Ошибка загрузки (null если нет ошибки) */
  error: string | null
  
  // Методы для работы с уведомлениями
  /** Загрузка полного списка уведомлений (вызывать при открытии окна) */
  fetchAll: () => Promise<void>
  markAsRead: (notificationIds: string[]) => Promise<void>
  loadMore: () => Promise<void>
  refresh: () => Promise<void>
}

const NotificationContext = createContext<NotificationContextType | undefined>(undefined)

export { NotificationContext }
